import _ from 'lodash';
import store from './store';
import { isObjectNotEmpty, isStringNotNull } from './tools';
import { SPLASH, SUITABLE_ORDER_TYPES, BIBORNE } from '../constants'
import { unflattenObject } from 'topkat-utils'
import moment from 'moment';
import { hasExternalIntegration } from './externalIntegration';
import { updateMenuPosition } from '../apis/backend';


export const parseMenu = async (menu) => {
  const { categories = {}, sections = {} } = menu;
  const updates = {};
  const sortedSections = Object.keys(sections)
    .sort((a, b) => sections[a].position - sections[b].position);
  sortedSections.forEach((sectionKey, i) => {
    const { products = {} } = sections[sectionKey];
    if (sections[sectionKey].key) {
      if (sections[sectionKey].position !== i) {
        sections[sectionKey].position = i;
        updates[`sections.${sectionKey}.position`] = i;
      }
    }
    else {
      updates[`sections.${sectionKey}.position`] = null;
    }
    if (products) {
      const sortedProducts = Object.keys(products)
        .sort((a, b) => products[a].position - products[b].position);

      sortedProducts.forEach((productKey, index) => {
        if (products[productKey].key) {
          if (products[productKey].position !== index) {
            products[productKey].position = index;
            updates[`sections.${sectionKey}.products.${productKey}.position`] = index;
          }
        }
        else {
          updates[`sections.${sectionKey}.products.${productKey}.position`] = null;
        }
      });
    }
  });

  if (categories) {
    _.map(categories, (category, key) => {
      const { items } = category;
      if (items) {
        const sortedItems = Object.keys(items)
          .sort((a, b) => items[a].position - items[b].position);

        sortedItems.forEach((itemKey, index) => {
          if (items[itemKey].position !== key) {
            if (items[itemKey].position !== index) {
              items[itemKey].position = index;
              updates[`categories.${key}.items.${itemKey}.position`] = index;
            }
          }
          else {
            updates[`categories.${key}.items.${itemKey}.position`] = null;
          }
        });
      }
    });
  }

  if (isObjectNotEmpty(updates)) {
    await updateMenuPosition(unflattenObject(updates))

  }
};


export const updateOrderTypes = (shopName, orderTypes) => {
  const { shops = {} } = store.getState().firebaseRealTime;
  const newOrderTypes = [...orderTypes['Commande à distance']];
  if (shops) _.keys(shops).forEach(shop => {
    if (shop !== shopName) {
      const { configuration = {} } = shops[shop];
      const { orderTypes: shopOrderTypes = [] } = configuration;
      if (shopOrderTypes) shopOrderTypes.forEach(shopType => {
        if (!newOrderTypes.includes(shopType)) {
          newOrderTypes.push(shopType);
        }
      })
    }
  })
  return newOrderTypes;
}

export const isValidAddress = arrayAddress => {
  const filtredAddress = arrayAddress.filter(address => {
    const { types } = address;
    return types.includes('country') || types.includes('route') || types.includes('locality');
  });
  return filtredAddress.length < 3;
}

const getAddressType = (arrayAddress, param) => {
  return arrayAddress.find(address => address.types.includes(param)) || {};
}

export const formatAddress = arrayAddress => {
  return {
    city: getAddressType(arrayAddress, 'locality').long_name || '',
    postalCode: getAddressType(arrayAddress, 'postal_code').long_name || '',
    street: getAddressType(arrayAddress, 'route').long_name || '',
    country: getAddressType(arrayAddress, 'country').long_name || '',
    streetNumber: getAddressType(arrayAddress, 'street_number').long_name || '',
    region: getAddressType(arrayAddress, 'administrative_area_level_1').long_name || ''
  };
}

export const getOrderTypes = savedOrderTypes => {
  return _.map(savedOrderTypes, i => {
    return SUITABLE_ORDER_TYPES[i];
  });
}
export function intersectionObjects(obj1, obj2) {
  const result = {};
  for (let i in obj1) {
    for (let j in obj2) {
      if (obj1[i].key === obj2[j].key) {
        result[obj1[i].key] = obj1[i]
      }
    }
  }

  return result;
}

export const handleSynchronisationToggle = (value, index, component) => {
  const { selectedShops } = component.state;
  const currentIndex = _.keys(selectedShops).indexOf(index);
  const newChecked = { ...selectedShops };
  if (currentIndex === -1) {
    newChecked[index] = value
  } else {
    delete newChecked[index];
  }
  component.setState({ selectedShops: newChecked });
};

export const debouncedUpdate = _.debounce(async (menu) => {
  await parseMenu(menu);
}, 500)

export const formatPhone = (phone, countryCode = '+33') => {
  if (isStringNotNull(phone)) {
    if (phone.startsWith('0') && phone.length > 1) {
      phone = phone.replace('0', countryCode);
    } else if (!phone.startsWith('+') && phone.length > 1) {
      phone = '+' + phone;
    }
  }
  return phone;
};
export const formatPhoneService = (component, value) => {
  if (component.phoneInput) {
    const {
      selectedCountry: { countryCode }
    } = component.phoneInput.state;
    value = formatPhone(value, countryCode);
  }
  return value;
};

export const phoneNumberMinLength = iso2 => {
  const minLengths = {
    fr: 9,
    be: 8,
    us: 10,
    no: 8,
    mc: 8,
    sw: 7,
    al: 8,
    de: 11
  };
  return minLengths[iso2] || 5;
};

export const formatSlot = (slot) => {
  if (!slot) return;
  const [startTime, endTime] = slot?.split('-');
  const formattedStartTime = formatHour(startTime);
  const formattedEndTime = formatHour(endTime);
  return `${formattedStartTime} à ${formattedEndTime}`;
};

export const formatHour = (hour) => {
  const [hh, mm] = hour.split(':');
  return `${hh}h${mm}`;
};

export const getDaysOfWeekForRange = (startDate, endDate) => {
  const days = [];
  const currentDate = moment(startDate);

  while (currentDate <= moment(endDate).endOf('day')) {
    const dayOfWeek = currentDate.format('dddd');
    days.push(dayOfWeek);
    currentDate.add(1, 'day');
  }

  return days;
};
export const shopWithoutMenuIntegrated = (shop) => _.get(shop, 'configuration.externalIntegration.configuration.withoutMenuIntegrated', false)

export const getShopsToSynchronise = () => {
  const { shops = {}, shop: originalShop = {} } = store.getState().firebaseRealTime;
  const hasIntegration = hasExternalIntegration(originalShop.shopId);
  const originalShopWithoutMenuIntegrated = shopWithoutMenuIntegrated(originalShop)
  const orginalShopMenuVersion = originalShop?.configuration?.menu?.version;
  return _.pickBy(shops, shop => {
    const shopIntegrationType = shop?.configuration?.externalIntegration?.type;
    const shopIntegrationEnabled = shop?.configuration?.externalIntegration?.enabled || false;
    const shopMenuVersion = shop?.configuration?.menu?.version;
    const biborneWithoutMenuIntegrated = shopIntegrationType === BIBORNE && shopWithoutMenuIntegrated(shop)
    const shouldSynchronize = (shopIntegrationType === hasIntegration && shopMenuVersion === orginalShopMenuVersion) || !shopIntegrationEnabled || biborneWithoutMenuIntegrated;

    if (hasIntegration && !originalShopWithoutMenuIntegrated) {
      return shouldSynchronize;
    } else {
      return !shopIntegrationEnabled || biborneWithoutMenuIntegrated;
    }
  });
};

export const getDisplayedCategories = (categories, originalCategories) => {
  const optionsWithPrdItems = {};
  if (hasExternalIntegration() === SPLASH) {
    _.entries(categories).forEach(([optionKey, option]) => {
      const { items = {} } = option;
      const prdItems = _.values(items).filter(item => item.ref?.startsWith('prd'));
      const selected = _.filter(originalCategories, item => item.key === optionKey);
      if (prdItems.length > 0 || selected.length > 0) {
        _.assign(optionsWithPrdItems, { [optionKey]: option })
      }
    })
    return optionsWithPrdItems;
  }

  else return categories
}

export const getSplashCategories = (categories, selectedCategories) => {
  const optionsWithPrdItems = {};
  _.entries(categories).forEach(([optionKey, option]) => {
    const { items = {} } = option;
    const prdItems = _.values(items).filter(item => item.ref.startsWith('prd'));
    const selected = selectedCategories.filter(item => item.key === optionKey);
    if (prdItems.length > 0 || selected.length > 0) {
      _.assign(optionsWithPrdItems, { [optionKey]: option })
    }

  });
  return optionsWithPrdItems;
}